import { ReactNode, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import t from "@/lang/lang";
import { Dialog, DialogContent } from "@/shared/components/ui/dialog";
import {
  CommonDialogFooter,
  CommonDialogHeader,
  CommonDialogTrigger,
} from "@/shared/components/dialog/dialog-common";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useOmniContractDeleteMutation } from "@/services/backend/omni/contract/api/contract-api";

export function ContractDeleteDialog({
  contractId,
  onDeleted,
  trigger,
}: {
  contractId: string;
  onDeleted?: () => void;
  trigger?: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const [deleteContract, { isLoading, error, reset }] =
    useOmniContractDeleteMutation();

  const onConfirm = () => {
    if (isLoading) {
      return;
    }
    deleteContract({ id: contractId })
      .unwrap()
      .then(() => {
        toast.success(t("Vertrag gelöscht"));
        reset();
        setOpen(false);
        onDeleted?.();
      })
      .catch(() => {
        // The error is shown by the RTKQueryErrorAlert.
      });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {trigger || (
        <CommonDialogTrigger icon={Trash2} label="" variant="destructive" />
      )}
      <DialogContent>
        <CommonDialogHeader
          title={t("Vertrag wirklich löschen?")}
          description={t(
            "Der Vertrag wird mit allen Positionen gelöscht. Dies kann nicht rückgängig gemacht werden.",
          )}
        />
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter
          isLoading={isLoading}
          onClickAction={onConfirm}
          actionLabel={t("Löschen")}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
